/* „Dein Jahr bei Lorayn“ (Vorlage page.app-jahr, Abschnitt „App: Dein Jahr“).
   Die App liefert die Bestellungen des Jahres nur an diese Seite (Checkout.year); ausgewertet wird hier auf dem Gerät,
   gespeichert wird nichts. Am Ende lässt sich eine Karte als Bild teilen (AppBridge.shareImage). */
(() => {
  const root = document.querySelector('[data-yr]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-yr-config]').textContent);
  const T = cfg.t;
  const stage = root.querySelector('[data-yr-stage]');
  const dots = root.querySelector('[data-yr-dots]');
  const P = (window.Capacitor && window.Capacitor.Plugins) || {};
  const app = document.documentElement.classList.contains('is-app');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (s, v) => String(s || '').replace(/\{name\}/g, v.name || '').replace(/\{n\}/g, v.n == null ? '' : v.n)
    .replace(/\{x\}/g, v.x || '').replace(/\{year\}/g, cfg.year).replace(/\{code\}/g, cfg.code || '').replace(/^,\s*|\s+,/g, (m) => (m.trim() === ',' ? '' : m));
  const haptic = (style) => P.Haptics && P.Haptics.impact({ style }).catch(() => {});

  /* deutsche Zeit */
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit' });
  const berlin = (d) => {
    const p = {};
    fmt.formatToParts(d).forEach((x) => { p[x.type] = Number(x.value); });
    return { y: p.year, m: p.month, d: p.day, h: p.hour % 24 };
  };
  const now = berlin(new Date());
  if (!cfg.year) cfg.year = now.m === 1 ? now.y - 1 : now.y;
  const md = (s) => { const m = String(s || '').match(/(\d{1,2})\s*\.\s*(\d{1,2})/); return m ? Number(m[2]) * 100 + Number(m[1]) : null; };
  const open = () => {
    const f = md(cfg.from), t = md(cfg.to), n = now.m * 100 + now.d;
    if (f == null || t == null) return true;
    return f <= t ? n >= f && n <= t : n >= f || n <= t;
  };
  const design = window.Shopify && window.Shopify.designMode;

  const show = (html) => { stage.innerHTML = `<div class="yr__card">${html}</div>`; dots.innerHTML = ''; };

  if (!app && !design) { show(`<h1>${esc(T.web)}</h1>`); return; }
  if (!open() && !design) {
    const f = String(cfg.from || '').match(/(\d{1,2})\s*\.\s*(\d{1,2})/);
    const when = f ? new Intl.DateTimeFormat(document.documentElement.lang || 'de', { day: 'numeric', month: 'long' }).format(new Date(2000, Number(f[2]) - 1, Number(f[1]))) : '';
    show(`<h1>${esc(fill(T.soon, { x: when }))}</h1>`);
    return;
  }

  /* Auswertung */
  const top = (map) => Object.entries(map).sort((a, b) => b[1] - a[1])[0];
  const analyse = (orders, name) => {
    let pieces = 0, owl = 0;
    const colors = {}, titles = {}, types = {};
    const drops = (cfg.drops || []).map((d) => ({ name: d.name, at: Date.parse(d.start) })).filter((d) => d.at && new Date(d.at).getFullYear() === cfg.year);
    const joined = new Set();
    let fast = 0;
    orders.forEach((o) => {
      const at = new Date(o.at);
      if (berlin(at).h < 3) owl += 1;
      const drop = drops.find((d) => at >= d.at && at - d.at < 48 * 3600e3);
      if (drop) {
        joined.add(drop.name);
        if (at - drop.at < 10 * 60e3) fast += 1;
      }
      o.items.forEach((i) => {
        const q = Number(i.quantity) || 1;
        pieces += q;
        const title = String(i.title || '').split(' - ')[0].trim();
        if (title) titles[title] = (titles[title] || 0) + q;
        if (i.type) types[i.type] = (types[i.type] || 0) + q;
        (i.options || []).forEach((op) => {
          if (/farbe|colou?r/i.test(op.name || '') && op.value) colors[op.value] = (colors[op.value] || 0) + q;
        });
      });
    });
    const ranks = String(cfg.ranks || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((r) => r[1])
      .map((r) => ({ min: Number(r[0]) || 0, name: r[1] })).sort((a, b) => a.min - b.min);
    const rank = ranks.filter((r) => pieces >= r.min).pop();
    return { name, pieces, orders: orders.length, color: top(colors), fav: top(titles), type: top(types), drops: joined.size, fast, owl, rank: rank && rank.name };
  };

  /* Karten wie Stories: Antippen rechts = weiter, links = zurück */
  const cards = (s) => {
    const list = [`<p class="yr__eyebrow">${esc(cfg.shop)} · ${cfg.year}</p><h1>${esc(fill(T.intro, s))}</h1><p>${esc(T.introText)}</p>`];
    list.push(`<p class="yr__big">${s.pieces}</p><h2>${esc(fill(T.pieces, { n: s.pieces }))}</h2><p>${esc(fill(T.orders, { n: s.orders }))}</p>`);
    if (s.color) list.push(`<p class="yr__big yr__big--word">${esc(s.color[0])}</p><h2>${esc(fill(T.color, { x: s.color[0] }))}</h2>`);
    if (s.fav || s.type) list.push(`${s.fav ? `<h2>${esc(fill(T.fav, { x: s.fav[0] }))}</h2>` : ''}${s.type ? `<p>${esc(fill(T.type, { x: s.type[0] }))}</p>` : ''}`);
    if (s.drops) list.push(`<p class="yr__big">${s.drops}</p><h2>${esc(fill(T.drops, { n: s.drops }))}</h2>${s.fast ? `<p>${esc(fill(T.dropsFast, { n: s.fast }))}</p>` : ''}`);
    if (s.owl) list.push(`<p class="yr__big">🦉</p><h2>${esc(fill(T.owl, { n: s.owl }))}</h2>`);
    if (s.rank) list.push(`<p class="yr__eyebrow">${cfg.year}</p><h2>${esc(fill(T.rank, { x: s.rank }))}</h2>`);
    list.push(finale(s));
    return list;
  };
  const codeHtml = () => (cfg.code ? `<p>${esc(T.codeText)}</p><p class="yr__code"><b>${esc(cfg.code)}</b><button type="button" data-yr-copy>${esc(T.copy)}</button></p>` : '');
  const finale = (s) => `<h2>${esc(fill(T.thanks, s))}</h2><p>${esc(T.thanksText)}</p>${codeHtml()}${P.AppBridge && P.AppBridge.shareImage && s.pieces ? `<button type="button" class="btn btn--signal" data-yr-share>${esc(T.share)}</button>` : ''}`;

  const play = (list, s) => {
    let i = 0;
    dots.innerHTML = list.map(() => '<i></i>').join('');
    const go = (n) => {
      i = Math.max(0, Math.min(list.length - 1, n));
      stage.innerHTML = `<div class="yr__card yr__card--${i % 3}" role="button" tabindex="0" aria-label="${esc(T.tap)}">${list[i]}</div>`;
      dots.querySelectorAll('i').forEach((d, k) => d.classList.toggle('is-on', k <= i));
      bind(s);
      haptic('LIGHT');
    };
    stage.addEventListener('click', (e) => {
      if (e.target.closest('button')) return;
      go(e.clientX < window.innerWidth * 0.3 ? i - 1 : i + 1);
    });
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'Enter') { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft') go(i - 1);
    });
    go(0);
  };

  const bind = (s) => {
    const copy = stage.querySelector('[data-yr-copy]');
    if (copy) copy.addEventListener('click', () => navigator.clipboard && navigator.clipboard.writeText(cfg.code).then(() => { copy.textContent = T.copied; }).catch(() => {}));
    const share = stage.querySelector('[data-yr-share]');
    if (share) share.addEventListener('click', () => {
      share.disabled = true;
      P.AppBridge.shareImage({ data: image(s), text: fill(T.shareText, s) }).catch(() => {}).finally(() => { share.disabled = false; });
    });
  };

  /* Bild zum Teilen, 1080 × 1920 (Story-Format), ohne Code und ohne Namen */
  const image = (s) => {
    const c = document.createElement('canvas');
    c.width = 1080;
    c.height = 1920;
    const g = c.getContext('2d');
    const col = cfg.colors;
    const font = getComputedStyle(document.body).fontFamily || 'sans-serif';
    g.fillStyle = col.bg || '#111';
    g.fillRect(0, 0, 1080, 1920);
    g.fillStyle = col.accent || '#e33';
    g.fillRect(80, 220, 120, 14);
    g.fillStyle = col.text || '#fff';
    g.textBaseline = 'top';
    g.font = `700 52px ${font}`;
    g.fillText(`${cfg.shop} · ${cfg.year}`, 80, 280);
    const rows = [[String(s.pieces), fill(T.pieces, { n: s.pieces })]];
    if (s.color) rows.push([s.color[0], fill(T.color, { x: s.color[0] })]);
    if (s.drops) rows.push([String(s.drops), fill(T.drops, { n: s.drops })]);
    if (s.owl) rows.push(['🦉', fill(T.owl, { n: s.owl })]);
    if (s.rank) rows.push([s.rank, fill(T.rank, { x: s.rank })]);
    let y = 460;
    rows.slice(0, 5).forEach(([big, small]) => {
      g.fillStyle = col.accent || '#e33';
      g.font = `900 ${big.length > 8 ? 96 : 150}px ${font}`;
      g.fillText(big.slice(0, 18), 80, y);
      y += big.length > 8 ? 120 : 170;
      g.fillStyle = col.text || '#fff';
      g.font = `600 44px ${font}`;
      wrap(g, small, 80, y, 920, 54).forEach(() => { y += 54; });
      y += 60;
    });
    g.font = `700 40px ${font}`;
    g.fillText('lorayn-brawley.de', 80, 1780);
    return c.toDataURL('image/jpeg', 0.9);
  };
  const wrap = (g, text, x, y, max, lh) => {
    const lines = [];
    let line = '';
    String(text).split(' ').forEach((w) => {
      const t = line ? `${line} ${w}` : w;
      if (g.measureText(t).width > max && line) { lines.push(line); line = w; } else line = t;
    });
    if (line) lines.push(line);
    lines.forEach((l, k) => g.fillText(l, x, y + k * lh));
    return lines;
  };

  const C = P.Checkout;
  const load = () => {
    if (!C || !C.year) { show(`<h1>${esc(T.error)}</h1>`); return; }
    C.year({ year: cfg.year }).then((r) => {
      if (!r || !r.signedIn) {
        show(`<h1>${esc(T.signIn)}</h1><p>${esc(T.signInText)}</p><button type="button" class="btn btn--signal" data-yr-signin>${esc(T.signInBtn)}</button>`);
        stage.querySelector('[data-yr-signin]').addEventListener('click', () => C.signIn().then(load).catch(() => {}));
        return;
      }
      const s = analyse(r.orders || [], r.firstName || '');
      if (!s.orders) {
        show(`<h1>${esc(fill(T.intro, s))}</h1><p>${esc(T.none)}</p>${codeHtml()}`);
        bind(s);
        return;
      }
      play(cards(s), s);
    }).catch(() => show(`<h1>${esc(T.error)}</h1>`));
  };
  if (window.Capacitor) load(); else document.addEventListener('deviceready', load, { once: true });
})();
